/* Preload fonts for faster icon loading */
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
@import url('https://cdn.jsdelivr.net/npm/@mdi/font@7.2.96/css/materialdesignicons.min.css');

/* Override Chrome's autocomplete styles */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px rgb(254, 251, 255) inset !important;
  -webkit-text-fill-color: rgb(27, 27, 31) !important;
  transition: background-color 5000s ease-in-out 0s, height 150ms ease-out !important;
  box-sizing: border-box !important;
  min-height: 38px !important; /* Minimum height to prevent collapse */
  height: auto !important; /* Allow height to adjust based on content */
  padding: 8px 12px !important; /* Consistent padding */
  border: 1px solid rgb(226, 226, 236) !important;
  border-radius: 8px !important;
  width: 100% !important; /* Ensure full width */
  margin: 0 !important; /* Reset margins */
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px rgb(27, 27, 31) inset !important;
    -webkit-text-fill-color: rgb(228, 226, 230) !important;
    border: 1px solid rgb(69, 70, 79) !important;
  }
}

/* Remove autocomplete dropdown arrow */
input::-webkit-calendar-picker-indicator {
  display: none !important;
}

/* Remove autocomplete background color */
input:-webkit-autofill {
  background-color: transparent !important;
}

/* Style for autofill suggestions dropdown */
input:-webkit-autofill + ul {
  background-color: rgb(254, 251, 255) !important;
  color: rgb(27, 27, 31) !important;
  border: 1px solid rgb(226, 226, 236) !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  max-height: 200px !important; /* Prevent overly long dropdowns */
  overflow-y: auto !important; /* Add scrolling for long lists */
}

@media (prefers-color-scheme: dark) {
  input:-webkit-autofill + ul {
    background-color: rgb(27, 27, 31) !important;
    color: rgb(228, 226, 230) !important;
    border: 1px solid rgb(69, 70, 79) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
  }
}

/* Focus state */
input:-webkit-autofill:focus {
  border-color: rgb(0, 83, 219) !important;
  outline: none !important;
  box-shadow: 0 0 0 2px rgba(0, 83, 219, 0.2) !important;
}

@media (prefers-color-scheme: dark) {
  input:-webkit-autofill:focus {
    border-color: rgb(180, 197, 255) !important;
    box-shadow: 0 0 0 2px rgba(180, 197, 255, 0.2) !important;
  }
}

/* Add smooth transitions for dimension changes */
input {
  transition: all 150ms ease-out !important;
}

/* Ensure proper text alignment and overflow handling */
input {
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  line-height: 1.5 !important;
  font-size: 16px !important; /* Prevent iOS zoom on focus */
} 